// 图片基础域名
export const BASE_IMG_URL = process.env.REACT_APP_OSS_IMAGE_URL

// 单独图片
// export const logoUrl = `${BASE_IMG_URL}/logo.png`;
// export const homeBannerUrl = `${BASE_IMG_URL}/home/banner.jpg`;
// export const userAvatarUrl = `${BASE_IMG_URL}/user/avatar.png`;
// 工具函数：确保路径格式正确
const getImagePath = (path) => {
    // 移除路径开头多余的斜杠
    const cleanPath = path.replace(/^\//, '');
    return `${BASE_IMG_URL}/${cleanPath}`;
};
// Toast组件图片
export const Toast = {
    success: getImagePath('common/setPost/successToast.png'),
    warning: getImagePath('common/setPost/warning.png'),
 };

// 发帖页面
export const setPostImage = {
    blodFont: getImagePath('common/setPost/blodFont.png'),
    blodFontActive: getImagePath('common/setPost/blodFontActive.png'),
    atfirends: getImagePath('common/setPost/atfirends.png'),
    atfriendsActive: getImagePath('common/setPost/atfirendsActive.png'),
    colorBar: getImagePath('common/setPost/colorBar.png'),
    colorBarActive: getImagePath('common/setPost/colorBarActive.png'),
    expression: getImagePath('common/setPost/expression.png'),
    expressionActive: getImagePath('common/setPost/expressionActive.png'),
    italic: getImagePath('common/setPost/italic.png'),
    italicActive: getImagePath('common/setPost/italic-active.png'),
    links: getImagePath('common/setPost/links.png'),
    linksActive: getImagePath('common/setPost/linksActive.png'),
    photoBar: getImagePath('common/setPost/photoBar.png'),
    photoBarActive: getImagePath('common/setPost/photoBarActive.png'),
    strikethrough: getImagePath('common/setPost/strikethrough.png'),
    strikethroughActive: getImagePath('common/setPost/strikethrough-active.png'),
    topic: getImagePath('common/setPost/topic.png'),
    topicActive: getImagePath('common/setPost/topicActive-v2.png'),
    topicActive2: getImagePath('common/setPost/topicActive-v3.png'),
    videoBar: getImagePath('common/setPost/videoBar.png'),
    videoBarActive: getImagePath('common/setPost/videoBarActive.png'),
    vote: getImagePath('common/setPost/vote.png'),
    voteActive: getImagePath('common/setPost/vote-active.png'),
    delete: getImagePath('common/close.png'),
    deleteTopic: getImagePath('common/setPost/close-topic.png'),
    videoGray: getImagePath('common/setPost/video-gray-v2.png'),
    close: getImagePath('common/setPost/close-icon.png'),
    setting: getImagePath('common/setPost/setting-icon-v2.png'),
    contentSettingActive: getImagePath('common/setPost/cententSettingIcon.png'),

    // https://vivo-oss-sz-bbs-uat.oss-cn-shenzhen.aliyuncs.com/vivo-web/common/setPost/setting-download.png
    settingDownload:getImagePath('common/setPost/setting-download-v2.png'),
    photo:getImagePath('common/setPost/photo-h5-v2.png'),
    at:getImagePath('common/setPost/at-h5-v2.png'),
    emoji:getImagePath('common/setPost/emoji-h5-v2.png'),
    video:getImagePath('common/setPost/video-h5-v2.png'),
    topicH5:getImagePath('common/setPost/topic-h5-v2.png'),
    draft: getImagePath('common/setPost/draft-icon2.png'),
    draftActive: getImagePath('common/setPost/draft-icon-active2.png'),
    aiIcon:getImagePath('common/setPost/AiIcon-v2.png'),
    timeIcon:getImagePath('common/setPost/flyIcon-v2.png'), // 定时发布图标
    timeIconTime:getImagePath('common/setPost/timeIocn.png'), // 定时发布图标
    searchSetpost: getImagePath('common/setPost/search-setpost.png'),
    emptyIcon: getImagePath('common/null4.png'),
    emptyIconFriends: getImagePath('common/setPost/empty-icon-firends.png'),
    atCheckout: getImagePath('common/setPost/at-checkout3.png'),
    atCheckoutActive: getImagePath('common/setPost/at-checked-active3.png'),
    checkedActive: getImagePath('common/setPost/checked-active2.png'),
    checked: getImagePath('common/setPost/at-checkout2.png'),
    vIcon: getImagePath('common/setPost/v-icon.png'),
    closeIcon: getImagePath('common/setPost/close-icon.png'),
    removeIcon: getImagePath('common/setPost/reovem.png'),
    addIcon: getImagePath('common/setPost/add-icon.png'),
    addCover: 'https://club-files.vivo.com.cn/vivo-web/cover-upload-add/add-cover-c1561f088c44.png',
    // 蓝湖原始切图，已上传并校验生产 OSS。
    deleteCover: 'https://club-files.vivo.com.cn/vivo-web/cover-upload-delete/delete-cover-1fe6f99c19cb.png',
    emptyPosts: getImagePath('common/null5.png'),
    // 表单编辑器图标
    jiaSet: getImagePath('common/setPost/jiaSet.png'),
    deleteSet: getImagePath('common/setPost/deleteSet.png'),
    copySet: getImagePath('common/setPost/copySet.png'),
    upSet: getImagePath('common/setPost/upSet.png'),
    downSet: getImagePath('common/setPost/downSet.png'),
    addPhoto: getImagePath('common/setPost/addPhoto.png'),
    danxuanSet: getImagePath('common/setPost/danxuanSer.png'),
    duoxuanSet: getImagePath('common/setPost/duoxuanset.png'),
    wendaSet: getImagePath('common/setPost/wendaSet.png'),
    photoSet: getImagePath('common/setPost/photoSet.png'),
    fixedAtIcon: getImagePath('common/setPost/fei.png'), // 定时发布图标
    selectIcon: getImagePath('common/setPost/selectJt.png'),
    selectH5Icon: getImagePath('common/arrow_r4.png'),
};

// 封面裁剪预览：蓝湖原始切图，已上传并校验生产 OSS。
export const coverCropImage = {
    portrait: 'https://club-files.vivo.com.cn/vivo-web/cover-crop-preview/ratio-portrait-b692b5219ca5.png',
    square: 'https://club-files.vivo.com.cn/vivo-web/cover-crop-preview/ratio-square-31b098210c0f.png',
    landscape: 'https://club-files.vivo.com.cn/vivo-web/cover-crop-preview/ratio-landscape-6f85204a7728.png',
    comment: 'https://club-files.vivo.com.cn/vivo-web/cover-crop-preview/preview-comment-af860cda6def.png',
    like: 'https://club-files.vivo.com.cn/vivo-web/cover-crop-preview/preview-like-a4fd8a2d3ede.png',
    doubleLike: 'https://club-files.vivo.com.cn/vivo-web/cover-crop-preview/preview-double-like-7fd793de4f03.png',
};

// 通用图片
export const commonImage = {
    back: 'https://vivo-oss-sz-bbs.oss-cn-shenzhen.aliyuncs.com/vivo-web/common/backicon.png',
    official2: getImagePath('common/official2.png'),
    arrowB2: getImagePath('common/arrow_b2.png'),
};

// 帖子转换素材：通过蓝湖本地脚本上传，使用已校验的生产 OSS 地址。
export const threadConversionImage = {
    converting: "https://club-files.vivo.com.cn/vivo-web/post-conversion/converting-d41605071ef6.png",
};

// 用户等级头像角标（V1-V7）
export const getUserLevelBadge = (level: number | string) => {
    const normalizedLevel = Number(level);
    if (!Number.isInteger(normalizedLevel) || normalizedLevel < 1 || normalizedLevel > 7) return '';
    return `https://bbsfiles.iqoo.com/vivopc/V${normalizedLevel}_08041425.png`;
};

export const livePhotoImage = {
    liveIcon: getImagePath('common/live-icon.png'),
    volumeClose: getImagePath('common/volume-close.png'),
    volume: getImagePath('common/volume.png'),
};

export const photographyImage = {
    modelMask: getImagePath('photography/model.png'),
    emptyWorks: 'https://club-files.vivo.com.cn/vivo-web/photography-empty-works/v_theme_empty_sofa_ic-fd68b2e87c6f.png',
    videoIcon: 'https://club-files.vivo.com.cn/vivo-web/photography-video-badge/video-badge-8ecde0bcd0da.png',
};

// 蓝湖切图通过本地脚本上传并校验。
export const photographyVideoImage = {
    back: 'https://club-files.vivo.com.cn/vivo-web/photography-video-badge/video-back-bf0e7c793b46.png',
    detailReturn: 'https://club-files.vivo.com.cn/vivo-web/photography-video-badge/video-detail-return-6d5829de0d21.png',
    more: 'https://club-files.vivo.com.cn/vivo-web/photography-video-badge/video-more-cf5b7984cb37.png',
    pending: 'https://club-files.vivo.com.cn/vivo-web/photography-video-badge/video-pending-ec47bfe6e4eb.png',
    ai: 'https://club-files.vivo.com.cn/vivo-web/photography-video-badge/video-ai-9582a61e1227.png',
    warning: 'https://club-files.vivo.com.cn/vivo-web/photography-video-badge/video-warning-30b2111955ce.png',
    fullscreen: 'https://club-files.vivo.com.cn/vivo-web/photography-video-badge/video-fullscreen-7d6f7b83de8e.png',
    play: 'https://club-files.vivo.com.cn/vivo-web/photography-video-badge/video-play-accb11ddb01d.png',
    pause: 'https://club-files.vivo.com.cn/vivo-web/photography-video-badge/video-pause-000cf1a75597.png',
    qrLogo: 'https://club-files.vivo.com.cn/vivo-web/photography-video-badge/video-qr-logo-96bc7f7570b1.png',
};

export const sharePopupImage = {
    saveDark: 'https://bbsfiles.iqoo.com/icon/20250210/save.png',
    saveLight: 'https://bbsfiles.iqoo.com/iqoo-mini/exports/save.png',
};

// 下载app页面的二维码图片
export const qrcodeImage = {
    downloadCode: getImagePath('qrcode/downloadApp.png'),
    qrcodeVshop: getImagePath('qrcode/VivoAppMarket.png'),    // v币商店二维码图片
};


// 给V粉的一封信页面的二维码图片
export const qrcodeLetter = {
    code: getImagePath('qrcode/houseLetter.png'),
};

// 使用示例：import { logoUrl, homeImages } from '@images/imageUrls';
